export const EVENT_KYC_FILES_COUNT = "key_files.pending_count"
export const EVENT_RISK_ALERT = "risk-alert"
